var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"_chapter",on:{"click":_vm.goToChapter}},[_c('img',{attrs:{"src":_vm.chapter.thumbnail}}),_c('p',[_vm._v(_vm._s(_vm.chapter.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }